export default __webpack_public_path__ + "static/media/rtl.f93a5892.svg";